import { CollectionCard } from '@/components/blocks/collection/collection-card';
import {
  getCollectionCardPaddingClassName,
  getEnabledFields,
  resolveSymmetricPadding,
} from '@/lib/blocks/collection/blocks';
import { contentAlignClassName } from '@/lib/blocks/collection/index-collection/layout';
import { cn } from '@/lib/utils';
import { IndexCollectionCardLink } from './card-link';
import type { IndexCollectionCardComponentProps } from './index-collection-renderers';
import { indexCollectionCardShellClassName, resolveIndexCardConfig } from './utils';

export function CaseResultIndexCollectionCard({
  item,
  cardConfig,
  layout,
  renderField,
  variantProps,
  hasCardStyling = false,
}: IndexCollectionCardComponentProps) {
  const bodyAlignClassName = contentAlignClassName(cardConfig.align, layout === 'list');
  const useCardLinkFallback = !getEnabledFields(cardConfig.fields).some(
    (field) => field.kind === 'button',
  );

  return (
    <article
      className={cn(
        'relative flex h-full w-full flex-col',
        indexCollectionCardShellClassName(hasCardStyling),
        getCollectionCardPaddingClassName(resolveSymmetricPadding(variantProps, 'none')),
      )}
    >
      <CollectionCard
        item={item}
        cardConfig={resolveIndexCardConfig(cardConfig, variantProps)}
        renderField={renderField}
        paddingClassName={cn('flex-1', bodyAlignClassName, layout === 'list' && 'self-stretch')}
      />
      <IndexCollectionCardLink item={item} enabled={useCardLinkFallback} />
    </article>
  );
}
